import React from 'react';
import { Link } from 'react-router-dom';
import { Printer } from 'lucide-react';
import { Button } from './ui/button';

export const WorkOrderPrintButton = ({ workOrderId, testId, compact = false }) => <Button asChild variant="outline" size={compact ? 'icon' : 'sm'} className={compact ? 'h-8 w-8 shrink-0' : undefined}>
  <Link to={`/work-orders/${encodeURIComponent(workOrderId)}/print`} target="_blank" rel="noopener noreferrer"
    data-testid={testId || `print-work-order-btn-${workOrderId}`} aria-label="Open printable work order" title="Print work order">
    <Printer size={14} className={compact ? undefined : 'mr-1.5'} aria-hidden="true" />{!compact && 'Print'}
  </Link>
</Button>;